/*
|--------------------------------------------------------------------------
| Olive
|--------------------------------------------------------------------------
*/

/**
 * Olive
 * @namespace
 */
__gh__webApp.consumerMarketing.olive = {

	/**
	 * Data
	 */
	"data":{
		"tablet":	__gh__webApp.device.isTablet(),
		"user"  :	__gh__webApp.paywall.pianoVX.isUserLoggedIn(),
		"olive" :	__gh__coreData['3rdPartyData'].consumerMarketing.olive,
		"config":	("config" in __gh__coreData['3rdPartyData'].consumerMarketing.olive) ?  __gh__coreData['3rdPartyData'].consumerMarketing.olive.config : null
	},



	/**
	 * init
	 */
	"init":function(){
		var thisObject = __gh__webApp.consumerMarketing.olive;
		
		if(!thisObject.isDisabled()){return;}
		
		this.bindEvents();
	},
	


	/**
	 * isDisabled
	 */
	"isDisabled": function(){
		var commonJS = __gh__webApp.common;
		if(!commonJS.getObjectProperty(__gh__coreData['3rdPartyData'].consumerMarketing,"olive.config")){return false;}
		return true;
	},



	/**
	 * Bind Events
	 */
	"bindEvents": function(){
		$(document).on("click", "[data-gh-consumermarketing-event=olive]", function(event){
			event.preventDefault();
			__gh__webApp.consumerMarketing.olive.getOlive();
		});
	},



	/**
	 * Get Olive
	 */
	"getOlive": function(){
		var thisObject 	= __gh__webApp.consumerMarketing.olive,
			data 		= thisObject.data,
			config 		= data.config,
			user		= data.user,
			tablet 		= data.tablet,
			path		= (tablet && config.tablet) ? config.tablet : config.default;
		
		if (!user){
			__gh__webApp.paywall.showUserLoginForm({"callback" : "__gh__webApp.consumerMarketing.olive.updateExperience"});
			return;
		}
		thisObject.updateExperience();
	},



	/**
	 * Update Experience
	 */
	"updateExperience": function(){
		var thisObject 	= __gh__webApp.consumerMarketing.olive.data,
			tablet 		= thisObject.tablet,
			config 		= thisObject.config,
			path		= (tablet && config.tablet) ? config.tablet : config.default;
		
		__gh__webApp.paywall.refreshExperienceCallbacks.push({"callback":'__gh__webApp.consumerMarketing.olive.redirect'});
		__gh__webApp.paywall.refreshExperience();
	},




	/**
	 * Redirect
	 */
	"redirect":function(){
		var thisObject		= __gh__webApp.consumerMarketing.olive;
			oliveData 		= thisObject.data,
			vxStorageObj 	= JSON.parse(__gh__webApp.localStorage.getItem("_vxData")),
			tablet 			= oliveData.tablet,
			config 			= oliveData.config,
			user			= oliveData.user,
			email 			= (vxStorageObj.email) ? vxStorageObj.email : null,
			isSubscriber	= (vxStorageObj.access) ? 1 : 0,
			path			= (tablet && config.tablet) ? config.tablet : config.default,
			link 			= "http://dev.sso.dispatch.com/controller/olive.php?email="+email+"&config="+path;

		if (!isSubscriber) { 
			__gh__webApp.consumerMarketing.olive.redirectSubscriberError();
			return;
		}
		
		$.post( link , function( data ) {
			window.location.href = data.data;
		});
	},
	
	
	/**
	 * Redirect Subscriber Error
	 * User may successfully login but they must also be a subscriber or you get a modal
	 */
	"redirectSubscriberError": function(){
		var modal	= __gh__webApp.utilities.modal,
			baseURL	= __gh__coreData.siteData.baseURL;
		
		modal.openModal({
			"url": baseURL + "/section/?template=HTML_olive-subscriber-error"
		});
	}

};
